import _ from 'lodash';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { post } from 'store/request';
import { CATEGORY_LIST } from 'pages/manage/application/constants';

// 审核状态 1-审核中 2-审核通过 3-审核拒绝
export enum AuditStatus {
  auditing = 1,
  pass = 2,
  fail = 3,
}

// 上架状态
// 状态 0：待确认 1：正常 2：拒绝 20：删除 3-待上架 4-上架中 5-验收中 7已下架
export enum AppStatus {
  needSure = 0,
  onShelf = 1,
  refused = 2,
  pending = 3,
  shelfing = 4,
  checking = 5,
  underShelf = 7,
  deleted = 20,
}

// 获取应用状态
export const fetchAppStatusOptions = createAsyncThunk('manager/getAppStatusOptions', async () => {
  return [
    {
      label: '待确认',
      value: AppStatus.needSure,
    },
    {
      label: '已上架',
      value: AppStatus.onShelf,
    },
    {
      label: '拒绝',
      value: AppStatus.refused,
    },
    {
      label: '待上架',
      value: AppStatus.pending,
    },
    {
      label: '上架中',
      value: AppStatus.shelfing,
    },
    {
      label: '验收中',
      value: AppStatus.checking,
    },
    {
      label: '已下架',
      value: AppStatus.underShelf,
    },
    {
      label: '删除',
      value: AppStatus.deleted,
    },
  ];
});

// 应用一级分类
export const fetchAppCategoryOptions = createAsyncThunk('manager/getAppCategoryOptions', async () => {
  return [];
});
// 应用二级分类
export const fetchAppSecondCategoryOptions = createAsyncThunk('manager/getAppSecondCategoryOptions', async () => {
  return [];
});

// 获取审核状态
export const fetchAuditOptions = createAsyncThunk('manager/fetchAuditOptions', async () => {
  return [
    {
      label: '审核中',
      value: AuditStatus.auditing,
    },
    {
      label: '审核通过',
      value: AuditStatus.pass,
    },
    {
      label: '审核未通过',
      value: AuditStatus.fail,
    },
  ];
});

// 应用类型
export const fetchAppTypeOptions = createAsyncThunk('manager/getAppTypeOptions', async () => {
  return CATEGORY_LIST;
});

let csIndustryTreeRes = '';
const csIndustryTreeHash = {};
// 开户行业树
export const getCsIndustryTree = createAsyncThunk('manager/getCsIndustryTree', async () => {
  if (!csIndustryTreeRes) {
    csIndustryTreeRes = await post('/meta/industry', { level: 1 });
  }
  return _.map(csIndustryTreeRes, ({ industry_id: value, display_name: label }: any) => {
    // @ts-ignore
    csIndustryTreeHash[value] = label;
    return {
      label,
      value,
      desc: label,
    };
  });
});

interface managerState {
  appStatusOptions: [];
  appCategoryOptions: [];
  appSecondCategoryOptions: [];
  auditOptions: [];
  appTypeOptions: [];
  csIndustryTree: [];
  csIndustryTreeHash: { [key: string]: any };
  areaList: [];
}

const initialState: managerState = {
  appStatusOptions: [],
  appCategoryOptions: [],
  appSecondCategoryOptions: [],
  auditOptions: [],
  appTypeOptions: [],
  csIndustryTree: [],
  csIndustryTreeHash: {},
  areaList: [],
};

const manageSlice = createSlice({
  name: 'manager',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAppStatusOptions.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.appStatusOptions = payload;
    });
    builder.addCase(fetchAppCategoryOptions.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.appCategoryOptions = payload;
    });
    builder.addCase(fetchAppSecondCategoryOptions.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.appSecondCategoryOptions = payload;
    });
    builder.addCase(fetchAuditOptions.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.auditOptions = payload;
    });
    builder.addCase(fetchAppTypeOptions.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.appTypeOptions = payload;
    });
    builder.addCase(getCsIndustryTree.fulfilled, (state, { payload }: PayloadAction<any>) => {
      state.csIndustryTree = payload;
      state.csIndustryTreeHash = csIndustryTreeHash;
    });
  },
});

export default manageSlice;
